import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'dhl-fields-number-separate',
  templateUrl: './fields-number-separate.component.html',
  styleUrls: ['./fields-number-separate.component.scss']
})
export class FieldsNumberSeparateComponent {

  @ViewChild('num1') num1!: ElementRef;
  @ViewChild('num2') num2!: ElementRef;
  @ViewChild('num3') num3!: ElementRef;
  @ViewChild('num4') num4!: ElementRef;
  @ViewChild('num5') num5!: ElementRef;
  @ViewChild('num6') num6!: ElementRef;
  @ViewChild('num7') num7!: ElementRef;
  @ViewChild('num8') num8!: ElementRef;

  keypressInput(event: any, inputRef: any) {
    const input = event.target as HTMLInputElement;
    const newValue = input.value.slice(0, 1);
    input.value = newValue;
    if (input.value.length > 0) {
      inputRef.focus();
    }
  }

  getValueCodeConfirm(): string{
    return `${this.num1.nativeElement.value}${this.num2.nativeElement.value}${this.num3.nativeElement.value}${this.num4.nativeElement.value}${this.num5.nativeElement.value}${this.num6.nativeElement.value}${this.num7.nativeElement.value}${this.num8.nativeElement.value}`;
  }
}
